export default "__VITE_PUBLIC_ASSET__b26ef5fa__"